import { type ChangeEvent, type KeyboardEvent, useState, useEffect } from "react";

interface UsePaginationInputProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

export function usePaginationInput({
  currentPage,
  totalPages,
  onPageChange,
}: UsePaginationInputProps) {
  const [pageInput, setPageInput] = useState(String(currentPage));

  // Update input when currentPage changes externally
  useEffect(() => {
    setPageInput(String(currentPage));
  }, [currentPage]);

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    setPageInput(e.target.value.replace(/[^0-9]/g, ''));
  };

  const handlePageSubmit = () => {
    const parsedPage = Number.parseInt(pageInput, 10);
    if (!Number.isNaN(parsedPage) && parsedPage >= 1 && parsedPage <= totalPages) {
      onPageChange(parsedPage);
    } else {
      // Reset to current page if invalid
      setPageInput(String(currentPage));
    }
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handlePageSubmit();
    }
  };

  const handleInputBlur = () => {
    handlePageSubmit();
  };

  return {
    pageInput,
    handleInputChange,
    handleKeyDown,
    handleInputBlur,
  };
}